import { petshopbackground } from "../css/backgroundcss.css";
import Footer from '../components/Footer';
import Articuloscard from "./Articuloscard";
import ShopLaunch from "../components/ShopLaunch"
import Profileinterno from "./Profileinterno";
const Shop = () => {
    return(
        <div >
        <div>
        <Profileinterno/>
        </div>    
    <ShopLaunch/>
          
            
        </div>
    )
}
export default Shop